// src/App.js
import React from "react";
import BusinessFaq from "./businessApp/faq";
import BusinessPrivacyPolicy from "./businessApp/privacypolicy";
import BusinessTermsAndConditions from "./businessApp/termsandconditions";
import UserFaq from "./userApp/faq";
import UserPrivacyPolicy from "./userApp/privacypolicy";
import UserTermsAndConditions from "./userApp/termsandconditions";
import UserCommunityGuidelines from "./userApp/community-guidelines";
import UserDeleteAccount from "./userApp/delete-account";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/faq" element={<UserFaq />} />
        <Route path="/privacy-policy" element={<UserPrivacyPolicy />} />
        <Route
          path="/terms-and-conditions"
          element={<UserTermsAndConditions />}
        />
        <Route
          path="/community-guidelines"
          element={<UserCommunityGuidelines />}
        />
        <Route path="/delete-account" element={<UserDeleteAccount />} />
        <Route path="/business/faq" element={<BusinessFaq />} />
        <Route
          path="/business/privacy-policy"
          element={<BusinessPrivacyPolicy />}
        />
        <Route
          path="/business/terms-and-conditions"
          element={<BusinessTermsAndConditions />}
        />
      </Routes>
    </Router>
  );
}

export default App;
